import { render } from "./BottomPlayer.vue?vue&type=template&id=08168cf8&scoped=true"
import script from "./BottomPlayer.vue?vue&type=script&lang=js"
export * from "./BottomPlayer.vue?vue&type=script&lang=js"

import "./BottomPlayer.vue?vue&type=style&index=0&id=08168cf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08168cf8"]])

export default __exports__